/*
 *
 * NotificationsAlerts
 *
 * this component connects the redux state notifications Alerts floatty
 * Set type of alert and message
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Alert } from "@domestika-dev/prudencio/dist/atoms/Alert";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { Box } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { FormattedMessage } from "react-intl";
import { closeNotificationAlert } from "./actions";

const NotificationsAlerts = ({ notificationsAlerts, dispatch }) => {
  const { type, isOpened, message } = notificationsAlerts;
  useEffect(() => {
    if (isOpened) {
      const timer = setTimeout(() => dispatch(closeNotificationAlert()), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpened]);

  let defaultMessage = "projects.new.saved.success";

  if (type !== "success") {
    defaultMessage = "projects.new.error";
  }

  const notificationMessage = message || defaultMessage;

  return (
    <>
      {isOpened && (
        <Box
          width="100%"
          maxWidth={["527px", "927px", "1199px"]}
          paddingX={[5]}
          left="50%"
          style={{ transform: "translateX(-50%)" }}
          position="fixed"
          top={8}
          zIndex={1055}
        >
          <Alert type={type} id={type} isClosable>
            <Text size="micro">
              <FormattedMessage id={notificationMessage} />
            </Text>
          </Alert>
        </Box>
      )}
    </>
  );
};

export default connect(state => ({
  notificationsAlerts: state.notificationsAlerts,
}))(NotificationsAlerts);

NotificationsAlerts.propTypes = {
  notificationsAlerts: PropTypes.shape({
    type: PropTypes.string.isRequired,
    isOpened: PropTypes.bool.isRequired,
    message: PropTypes.string,
  }).isRequired,
};
